/* unplugin-vue-components disabled */import script from "./WORoleList.vue?vue&type=script&setup=true&lang=js"
export * from "./WORoleList.vue?vue&type=script&setup=true&lang=js"

import "./WORoleList.vue?vue&type=style&index=0&id=bd9e40b4&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd9e40b4"]])

export default __exports__